import httpClient from './api/httpClient';

const END_POINT = 'processo-seletivo';
export const getAll = () => httpClient.get(END_POINT + '/all');
export const getAllPublico = () => httpClient.get(END_POINT + '/allPublico');

export const create = (ps) => {
    let psForm = {
        descricao: ps.descricao,
        salarioReferencia: ps.salarioReferencia,
    };
    return httpClient.post(END_POINT, psForm);
}